var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-overlay',{attrs:{"show":_vm.showOverlay}},[_c('b-embed',{attrs:{"type":"iframe","src":_vm.src,"aspect":_vm.aspect,"allowfullscreen":_vm.allowfullscreen},on:{"load":_vm.loaded}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }